import classNames from 'classnames';
import { BodyText } from 'palette/Typography';
import { BEMBlock } from '@helpers/classnames';
import '../styles/GlobalSearchSuggestedQuery.scss';

interface GlobalSearchSuggestedQueryProps {
    label: string;
    searchTerm: string;
    suggestedQuery: string;
}

function GlobalSearchSuggestedQuery({ label, searchTerm, suggestedQuery }: GlobalSearchSuggestedQueryProps) {
    const [block] = BEMBlock('global-search-suggested-query');
    const regex = new RegExp(`(${searchTerm}|${suggestedQuery})\\b`, 'gi');
    const splitLabel = label.split(regex);

    const highlightedLabel = splitLabel.map((part: string, index: number) => {
        const isHighlighted = part === searchTerm || part === suggestedQuery;
        const key = `${part}-${index}`;

        return (
            <BodyText
                key={key}
                level="1"
                weight={isHighlighted ? 'bold' : 'regular'}
            >
                {part}
            </BodyText>
        );
    });

    return (
        <div className={classNames(block)}>
            {highlightedLabel}
        </div>
    );
}

export default GlobalSearchSuggestedQuery;
